/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * SVM API
 * SVM API documentation
 * OpenAPI spec version: 1.0
 */
import type {
    DroneCreateRequest,
    DroneOperationalStatusUpdateRequest,
    DroneResponse,
    DroneStatusUpdateRequest,
    DroneUpdateRequest,
    GetDronesParams,
    PagedResponseDroneResponse
} from '../models';

export type getDroneResponse200 = {
    data: DroneResponse;
    status: 200;
};

export type getDroneResponse400 = {
    data: void;
    status: 400;
};

export type getDroneResponse500 = {
    data: void;
    status: 500;
};

export type getDroneResponseSuccess = getDroneResponse200 & {
    headers: Headers;
};

export type getDroneResponseError = (getDroneResponse400 | getDroneResponse500) & {
    headers: Headers;
};

export type getDroneResponse = getDroneResponseSuccess | getDroneResponseError;

export const getGetDroneUrl = (droneId: string) => `/api/v1/drones/${droneId}`;

export const getDrone = async (
    droneId: string,
    options?: RequestInit
): Promise<getDroneResponse> => {
    const res = await fetch(getGetDroneUrl(droneId), {
        ...options,
        method: 'GET'
    });

    const contentType = (res.headers.get('content-type') ?? '').toLowerCase();
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();

    const data: getDroneResponse['data'] = body
        ? contentType.includes('json')
            ? JSON.parse(body)
            : body
        : {};

    return { data, headers: res.headers, status: res.status } as getDroneResponse;
};

export type updateDroneResponse200 = {
    data: DroneResponse;
    status: 200;
};

export type updateDroneResponse400 = {
    data: void;
    status: 400;
};

export type updateDroneResponse500 = {
    data: void;
    status: 500;
};

export type updateDroneResponseSuccess = updateDroneResponse200 & {
    headers: Headers;
};

export type updateDroneResponseError = (updateDroneResponse400 | updateDroneResponse500) & {
    headers: Headers;
};

export type updateDroneResponse = updateDroneResponseSuccess | updateDroneResponseError;

export const getUpdateDroneUrl = (droneId: string) => `/api/v1/drones/${droneId}`;

export const updateDrone = async (
    droneId: string,
    droneUpdateRequest: DroneUpdateRequest,
    options?: RequestInit
): Promise<updateDroneResponse> => {
    const res = await fetch(getUpdateDroneUrl(droneId), {
        ...options,
        body: JSON.stringify(droneUpdateRequest),
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        method: 'PUT'
    });

    const contentType = (res.headers.get('content-type') ?? '').toLowerCase();
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();

    const data: updateDroneResponse['data'] = body
        ? contentType.includes('json')
            ? JSON.parse(body)
            : body
        : {};

    return { data, headers: res.headers, status: res.status } as updateDroneResponse;
};

export type updateDroneStatusResponse200 = {
    data: DroneResponse;
    status: 200;
};

export type updateDroneStatusResponse400 = {
    data: void;
    status: 400;
};

export type updateDroneStatusResponse500 = {
    data: void;
    status: 500;
};

export type updateDroneStatusResponseSuccess = updateDroneStatusResponse200 & {
    headers: Headers;
};

export type updateDroneStatusResponseError = (
    | updateDroneStatusResponse400
    | updateDroneStatusResponse500
) & {
    headers: Headers;
};

export type updateDroneStatusResponse =
    | updateDroneStatusResponseSuccess
    | updateDroneStatusResponseError;

export const getUpdateDroneStatusUrl = (droneId: string) => `/api/v1/drones/${droneId}/status`;

export const updateDroneStatus = async (
    droneId: string,
    droneStatusUpdateRequest: DroneStatusUpdateRequest,
    options?: RequestInit
): Promise<updateDroneStatusResponse> => {
    const res = await fetch(getUpdateDroneStatusUrl(droneId), {
        ...options,
        body: JSON.stringify(droneStatusUpdateRequest),
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        method: 'PUT'
    });

    const contentType = (res.headers.get('content-type') ?? '').toLowerCase();
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();

    const data: updateDroneStatusResponse['data'] = body
        ? contentType.includes('json')
            ? JSON.parse(body)
            : body
        : {};

    return { data, headers: res.headers, status: res.status } as updateDroneStatusResponse;
};

export type updateDroneOperationalStatusResponse200 = {
    data: DroneResponse;
    status: 200;
};

export type updateDroneOperationalStatusResponse400 = {
    data: void;
    status: 400;
};

export type updateDroneOperationalStatusResponse500 = {
    data: void;
    status: 500;
};

export type updateDroneOperationalStatusResponseSuccess =
    updateDroneOperationalStatusResponse200 & {
        headers: Headers;
    };

export type updateDroneOperationalStatusResponseError = (
    | updateDroneOperationalStatusResponse400
    | updateDroneOperationalStatusResponse500
) & {
    headers: Headers;
};

export type updateDroneOperationalStatusResponse =
    | updateDroneOperationalStatusResponseSuccess
    | updateDroneOperationalStatusResponseError;

export const getUpdateDroneOperationalStatusUrl = (droneId: string) =>
    `/api/v1/drones/${droneId}/operational-status`;

export const updateDroneOperationalStatus = async (
    droneId: string,
    droneOperationalStatusUpdateRequest: DroneOperationalStatusUpdateRequest,
    options?: RequestInit
): Promise<updateDroneOperationalStatusResponse> => {
    const res = await fetch(getUpdateDroneOperationalStatusUrl(droneId), {
        ...options,
        body: JSON.stringify(droneOperationalStatusUpdateRequest),
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        method: 'PUT'
    });

    const contentType = (res.headers.get('content-type') ?? '').toLowerCase();
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();

    const data: updateDroneOperationalStatusResponse['data'] = body
        ? contentType.includes('json')
            ? JSON.parse(body)
            : body
        : {};

    return {
        data,
        headers: res.headers,
        status: res.status
    } as updateDroneOperationalStatusResponse;
};

export type getDronesResponse200 = {
    data: PagedResponseDroneResponse;
    status: 200;
};

export type getDronesResponse400 = {
    data: void;
    status: 400;
};

export type getDronesResponse500 = {
    data: void;
    status: 500;
};

export type getDronesResponseSuccess = getDronesResponse200 & {
    headers: Headers;
};

export type getDronesResponseError = (getDronesResponse400 | getDronesResponse500) & {
    headers: Headers;
};

export type getDronesResponse = getDronesResponseSuccess | getDronesResponseError;

export const getGetDronesUrl = (params?: GetDronesParams) => {
    const normalizedParams = new URLSearchParams();

    Object.entries(params || {}).forEach(([key, value]) => {
        const explodeParameters = ['sort', 'ownershipStatus', 'operationalStatus', 'status'];

        if (Array.isArray(value) && explodeParameters.includes(key)) {
            value.forEach(v => {
                normalizedParams.append(key, v === null ? 'null' : String(v));
            });

            return;
        }

        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });

    const stringifiedParams = normalizedParams.toString();

    return stringifiedParams.length > 0 ? `/api/v1/drones?${stringifiedParams}` : `/api/v1/drones`;
};

export const getDrones = async (
    params?: GetDronesParams,
    options?: RequestInit
): Promise<getDronesResponse> => {
    const res = await fetch(getGetDronesUrl(params), {
        ...options,
        method: 'GET'
    });

    const contentType = (res.headers.get('content-type') ?? '').toLowerCase();
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();

    const data: getDronesResponse['data'] = body
        ? contentType.includes('json')
            ? JSON.parse(body)
            : body
        : {};

    return { data, headers: res.headers, status: res.status } as getDronesResponse;
};

export type createDroneResponse201 = {
    data: DroneResponse;
    status: 201;
};

export type createDroneResponse400 = {
    data: void;
    status: 400;
};

export type createDroneResponse500 = {
    data: void;
    status: 500;
};

export type createDroneResponseSuccess = createDroneResponse201 & {
    headers: Headers;
};

export type createDroneResponseError = (createDroneResponse400 | createDroneResponse500) & {
    headers: Headers;
};

export type createDroneResponse = createDroneResponseSuccess | createDroneResponseError;

export const getCreateDroneUrl = () => `/api/v1/drones`;

export const createDrone = async (
    droneCreateRequest: DroneCreateRequest,
    options?: RequestInit
): Promise<createDroneResponse> => {
    const res = await fetch(getCreateDroneUrl(), {
        ...options,
        body: JSON.stringify(droneCreateRequest),
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        method: 'POST'
    });

    const contentType = (res.headers.get('content-type') ?? '').toLowerCase();
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();

    const data: createDroneResponse['data'] = body
        ? contentType.includes('json')
            ? JSON.parse(body)
            : body
        : {};

    return { data, headers: res.headers, status: res.status } as createDroneResponse;
};
